(function () {
  function addFullWidth() {
    var el = document.getElementById('insta-feed');
    if (el) {
      el.classList.add('full-width');
      return true;
    }
    return false;
  }

  if (!addFullWidth()) {
    var observer = new MutationObserver(function (mutations, obs) {
      if (addFullWidth()) obs.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
